import dayjs from 'dayjs';
import {
  DataModel,
} from '../../dto/data-model.js';
import { IProductWithSerialNumber } from '../../../contracts/product-with-serial-number.js';
import { Result } from '../../../utility/result.js';
import { ErrorLike } from '../../core/error-like.js';
import type { TicketPriceBreakdown } from '../../../payment/ticket-pricing.js';

export interface SerialNumberPricingContext {
  /** Shared pricing for this exact ticket, including its order/entry discount. */
  readonly ticketPricing: TicketPriceBreakdown;
}
import { SerialNumberStrategy } from './serial-number-strategy.js';

export abstract class SerialNumberPool extends DataModel {
  static readonly DELIMITER: string = '-';

  abstract get creationDate(): dayjs.Dayjs;
  abstract getStrategy(): SerialNumberStrategy;
  abstract getSerialNumber(product: IProductWithSerialNumber, pricingContext?: SerialNumberPricingContext): Result<string, ErrorLike>;
}
